var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    attrs: {
      "playground": true,
      "title": _vm.title
    },
    on: {
      "show": _vm.focusPrimaryInput,
      "hidden": _vm.resetForm
    }
  }, [_c('div', {
    staticClass: "uk-modal-body"
  }, [_c('legal-text-picker', {
    ref: "primaryInput",
    attrs: {
      "filter": _vm.filter,
      "disabled": _vm.disabled
    },
    on: {
      "selectionConfirmed": _vm.submit
    },
    model: {
      value: (_vm.newLegalTexts),
      callback: function($$v) {
        _vm.newLegalTexts = $$v
      },
      expression: "newLegalTexts"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer uk-text-right"
  }, [_c('common-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('actions.add')) + "\n    ")]), _vm._v(" "), _c('common-button', {
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('actions.cancel')) + "\n    ")])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62525254","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LegalTextPickerModal.vue
// module id = 2018
// module chunks = 0